import React from 'react';
import { ScheduleTwoTone } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import './styles.less';

const { Text } = Typography;

const CreationSuccess = ({ configUrl, providerId }) => {
  const { t } = useTranslation();

  const handleDocumentationClick = () => {
    window.open(
      `${t('urls.appDocUrl', { provider: providerId.toLowerCase() })}#application`,
      '_blank',
      'noopener noreferrer',
    );
  };

  return (
    <div className="creation-success__container">
      <div className="creation-success__element">
        <ScheduleTwoTone className="creation-success__icon" twoToneColor="#a0d911" />
      </div>

      <div className="creation-success__element">
        <Text className="creation-success__title">
          {configUrl ? t('creationSuccess.titleConfig') : t('creationSuccess.titleNoConfig')}
        </Text>
        <Text className="creation-success__subtitle" type="secondary">
          {configUrl ? t('creationSuccess.configUrlText') : t('creationSuccess.noConfigUrlText')}
        </Text>
        <div>
          <Button onClick={handleDocumentationClick} type={configUrl ? 'default' : 'primary'}>
            Documentation
          </Button>
          {configUrl && (
            <Button
              className="creation-success__config-url-button"
              type="primary"
              href={configUrl}
              target="_blank"
            >
              {t('creationSuccess.configureProvider', { provider: providerId })}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

CreationSuccess.propTypes = {
  configUrl: PropTypes.string,
  providerId: PropTypes.string.isRequired,
};

CreationSuccess.defaultProps = {
  configUrl: '',
};

export default CreationSuccess;
